import styled from "styled-components";

export const BalanceInnerBox = styled.div`
    /* .cash-balance, .bonus-balance */
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    color: #ffffff;
`;
